import Marquee from "react-fast-marquee";

const items = [
  "Premium Design",
  "Fast Delivery",
  "SEO Optimized",
  "Mobile Friendly",
  "High Converting",
  "Affordable Pricing",
];

export default function EditorialMarquee() {
  return (
    <section
      data-testid="marquee-section"
      className="py-14 md:py-20 border-y border-white/10 bg-[#0a0a09] overflow-hidden"
    >
      <Marquee speed={40} gradient={false} autoFill>
        {items.map((t, i) => (
          <div key={i} className="flex items-center">
            <span className="font-serif-display italic text-5xl md:text-7xl px-10 text-white/90">
              {t}
            </span>
            <span className="w-2.5 h-2.5 rotate-45 bg-[#d4af37] mx-2" />
          </div>
        ))}
      </Marquee>
    </section>
  );
}
